<template>
  <div v-if="user" class="profile-wrap">
    <header>
      <img
        src="@/assets/no-image.png"
        alt="Profile Image"
        class="img-profile"
      />
      <h3 class="name">{{ user.fullname }}</h3>
      <p class="description">{{ user.department?.name }}</p>
    </header>
    <div class="profile-setting-wrap">
      <button @click="gotoProfileSetting">Ubah Profil</button>
      <button @click="gotoChangePassword">Ubah Kata Sandi</button>
    </div>
    <br /><br />
    <simple-list
      label="Tanggal Kunjungan Pertama"
      :text="formatDateForHuman(user.first_visit_date)"
    />
    <simple-list label="No. KTP" :text="user.id_card_number" />
    <simple-list
      label="Tanggal Lahir"
      :text="formatDateForHuman(user.date_of_birth)"
    />
    <simple-list
      label="Jenis Kelamin"
      :text="user.gender == 'M' ? 'Pria' : 'Wanita'"
    />
    <simple-list label="Agama" :text="user.religion" />
    <simple-list label="Alamat" :text="user.address" />
    <simple-list label="Pendidikan" :text="education" />
    <simple-list label="Pekerjaan" :text="user.profession" />
    <simple-list
      label="Status Perkawinan"
      :text="user.marital_status == '0' ? 'Tidak Menikah' : 'Menikah'"
    />
    <simple-list label="Golongan Darah" :text="user.blood_type" />
    <simple-list label="E-mail" :text="user.email" />
    <simple-list label="Nomor HP (WhatsApp)" :text="user.phone" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "profile",
  computed: {
    ...mapGetters({
      user: "user",
    }),
    education: function () {
      return this.educationList.find(
        (item) => item.value == this.user?.education
      )?.text;
    },
  },
  created: function () {},
  methods: {
    gotoProfileSetting: function () {
      this.$router.push({
        name: "profile-settings",
        params: { gender: this.user.gender },
      });
    },
    gotoChangePassword: function () {
      this.$router.push({ name: "change-password" });
    },
  },
};
</script>
